/* eslint-disable no-shadow */
import { PueblaPreviousYearsResponse } from 'Services/sat/types';
import EventService from 'Services/events';
import { history } from 'Store';
import StarsIcon from 'Components/icons/StarsIcon';
import BrokenHeart from 'Components/icons/BrokenHeart';
import BalanceIcon from 'Components/icons/BalanceIcon';
import { FRONT_PLANS } from 'Constants/plans';
import { routes } from 'Constants/routes';
import { ResultType, ResultTypes, TaxProfile } from 'Types/common';
import ResultBox from './components/ResultBox';
import ResultBoxNotReturn from './components/ResultBoxNotReturn';

export const MIN_TAX_RETURN_RESULT = 100;
export const MAX_TAX_RETURN_RESULT = 10000;

export const validationPayLater = (resultType: ResultType): boolean => {
  if (resultType.taxReturnType === ResultTypes.toReturn) {
    return false;
  }

  return true;
};

export const getResultPercentage = (result: number): number => {
  const MAX_PERCENTAGE = Math.floor(2499 * 0.8);
  const MIN_PERCENTAGE = Math.floor(299 * 0.8);
  const percentage = result * 0.2;

  if (Math.floor(percentage) > MIN_PERCENTAGE) {
    return percentage > MAX_PERCENTAGE ? MAX_PERCENTAGE : parseFloat(percentage.toFixed(2));
  }

  return MIN_PERCENTAGE;
};

export const getResultIsPayLater = (result: number, minimunPrice: number): boolean => {
  return Math.abs(result) > minimunPrice;
};

export const textsByType = {
  toPay: {
    header: 'Result.ToPay.title',
    subheader: 'Result.ToPay.subtitle',
    text: 'Result.ToPay.description',
    amountColor: 'cold',
  },
  zero: {
    header: 'Result.ToPay.title',
    subheader: 'Result.ToPay.subtitle',
    text: 'Result.ToPay.description',
    amountColor: 'cold',
  },
  toReturn: {
    header: 'Result.ToReturn.title',
    subheader: 'Result.ToReturn.subtitle',
    text: 'Result.toReturn.description',
    amountColor: 'fresh',
  },
  equal: {
    header: 'Result.equal.title',
    subheader: 'Result.equal.subtitle',
    text: 'Result.equal.description',
    amountColor: 'grey',
  },
};

export enum TaxReturnTypes {
  TO_RETURN = 'toReturn',
  TO_PAY = 'toPay',
  EQUAL = 'equal',
}

export const resultBoxComponent = {
  [TaxReturnTypes.TO_RETURN]: ResultBox,
  [TaxReturnTypes.EQUAL]: ResultBoxNotReturn,
  [TaxReturnTypes.TO_PAY]: ResultBoxNotReturn,
};

export const getIsInstantRefund = (data?: ResultType): boolean => {
  if (!data) {
    return false;
  }
  if (data.isRefundable?.length === 0) {
    return false;
  }
  if (data) {
    const hasWarning = data?.isRefundable?.some(item => item.id === 'O00074' && item.value !== 2);
    const resultAvailable =
      Math.abs(data.taxReturnResult) > 300 && Math.abs(data.taxReturnResult) < 3000;
    return (hasWarning && resultAvailable) || false;
  }

  return false;
};

export const getUserRedirectToPayLater = ({
  data,
  userComplex,
  plan,
}: {
  data: ResultType;
  userComplex?: TaxProfile;
  plan: FRONT_PLANS;
}): boolean => {
  return (
    Math.abs(data?.taxReturnResult) > MIN_TAX_RETURN_RESULT &&
    Math.abs(data?.taxReturnResult) < MAX_TAX_RETURN_RESULT &&
    userComplex === TaxProfile.SIMPLE &&
    data?.taxReturnType === TaxReturnTypes.TO_RETURN &&
    plan === FRONT_PLANS.BASIC
  );
};

export const IconByType = {
  [TaxReturnTypes.TO_RETURN]: StarsIcon,
  [TaxReturnTypes.TO_PAY]: BrokenHeart,
  [TaxReturnTypes.EQUAL]: BalanceIcon,
};

export const handleRedirectUser = ({
  plan,
  data,
  isInstantRefund,
  refund,
  isExtendedAndIsToReturn,
  isUserToPro,
  needEfirmaUser,
}: {
  plan: FRONT_PLANS;
  data: ResultType;
  isInstantRefund?: boolean;
  refund?: boolean;
  isExtendedAndIsToReturn?: boolean;
  isUserToPro?: boolean;
  needEfirmaUser?: boolean;
}): void => {
  if (plan && plan !== FRONT_PLANS.BASIC) {
    history.replace(routes.FILING, {
      taxReturnType: data?.taxReturnType,
      taxReturnResult: data?.taxReturnResult,
      isExtendedAndIsToReturn,
      plan: {
        name: plan,
      },
      isInstantRefund,
    });
  } else {
    const route = routes.UPSELLING_PRO;
    history.push(route, {
      successUrl: routes.CHECKOUT_SUCCESS_STEP,
      cancelUrl: routes.RESULT,
      route: routes.RESULT,
      taxReturnType: data?.taxReturnType,
      taxReturnResult: data?.taxReturnResult,
      section: 'result',
      result: data,
      instantRefund: refund,
      isUserToPro,
      fromFedUser: needEfirmaUser,
    });
  }
};

export const sendTaxReturnResultViewEvent = (
  data: ResultType,
  previousYearInfo?: PueblaPreviousYearsResponse,
  renderCrossSellAA?: boolean
): void => {
  if (data) {
    EventService.taxReturnResultView({
      daResultType: data?.taxReturnType,
      taxReturnResult: data?.taxReturnResult?.toString(),
      aaResultType: previousYearInfo?.refundStatusType ?? '',
      aaResult: previousYearInfo?.amountPending?.toString() ?? '',
      crossSellAA: renderCrossSellAA ?? false,
      taxReturnFilingType: data?.taxReturnFilingType ?? '',
    });
  }
};

export const getIsFlexNotMandatory = (
  data: ResultType,
  previousYearInfo?: PueblaPreviousYearsResponse,
  showPreviousYearBanner?: boolean
): boolean => {
  return (
    (data?.flexUser &&
      showPreviousYearBanner &&
      Math.abs(previousYearInfo?.amountPending ?? 0) > 700) ||
    false
  );
};
export const getIsFlexToPro = (data: ResultType, showPreviousYearBanner?: boolean): boolean => {
  return (data?.flexToPro && !showPreviousYearBanner) || false;
};
